"use client";

import Image from "next/image";
import Button from "@/app/components/ui/common/Button/page";

const PortfoliaoBanner = ({ path, content }) => {
    return (
        <div className="relative w-full h-screen overflow-hidden">
            <Image
                src={`/assets/${path}/${content[0]?.bgImage}.jpg`}
                alt={content[0]?.alt}
                fill
                style={{
                    objectFit: "cover",
                }}
            />

            <div className="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center">
                <div className="w-full text-center text-white 2xl:px-72 xl:px-52 lg:px-44 md:px-32 sm:px-7 px-6">
                    <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl !leading-snug font-extrabold font-manrope flex flex-col justify-center items-center">
                        {content[0]?.title}
                    </h2>
                    <p className="mt-3 sm:mt-5 md:mt-7 lg:mt-9 font-inter font-normal lg:text-lg text-base text-center lg:px-32 md:px-24 sm:px-7 px-4">
                        {content[0]?.description}
                    </p>
                    {content[0]?.buttonName && (
                        <div className="mt-10">
                            <Button className="btn-primary-purple">
                                {content[0]?.buttonName}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PortfoliaoBanner;
